/**
 * Customer auth helpers — parallel to lib/auth.js (admin) but with a distinct
 * localStorage key + token role so the two flows don't collide.
 */
import axios from "axios";

const KEY = "walnut_customer_token";
const API = `${process.env.REACT_APP_BACKEND_URL}/api/customer`;

export const getCustomerToken = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setCustomerToken = (t) => {
  try {
    if (t) localStorage.setItem(KEY, t);
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};

export const clearCustomerToken = () => setCustomerToken(null);

// Axios instance auto-attaches the token.
export const customerApi = axios.create({ baseURL: API });
customerApi.interceptors.request.use((config) => {
  const t = getCustomerToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
